---
nb:
  production_simulation_plan:
    axis_names:
      energy: Energi
      inflow_energy: Energi fra tilsig
      price: Pris
      reservoir_energy: Energi i magasin
      volume: Volum (MWh)
    chart_names:
      actual_market_price: Faktisk markedspris
      actual_production: Faktisk produksjon
      estimated_inflow: Estimert tilsig
      estimated_price: Estimert pris
      estimated_reservoir_volume: Estimert reservoarvolum
      past_planned_production: Tidligere planlagt produksjon
      planned_production: Planlagt produksjon
